module.exports = __webpack_public_path__ + "resources/img/img_passxpertv4_2.75b0a93e93a763c1944cc7be3997e07b.png";